import { useEffect, useState } from "react";
import { SupplierGetSupplierWarehouseById } from "../../Api/Services";
import { useParams } from "react-router-dom";

function SupplierWarehouse() {
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(true);

  let { id } = useParams();

  const start = async () => {
    try {
      const SupplierGetSupplierWarehouseByIdData =
        await SupplierGetSupplierWarehouseById(id);
      if (
        SupplierGetSupplierWarehouseByIdData.status &&
        SupplierGetSupplierWarehouseByIdData.status === 200
      ) {
        setData(SupplierGetSupplierWarehouseByIdData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="d-flex justify-content-center align-items-center w-100 p-2 tableC">
            <table className="table">
              <thead className="sticky-header">
                <tr className="trTable">
                  <th>Supplier</th>
                  <th>نوع</th>
                  <th>نام</th>
                  <th>شهر</th>
                  <th>ادرس</th>
                  <th>شماره</th>
                  <th>نام کامل</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td>{item.supplierName}</td>
                    <td>{item.warehouseTypeName}</td>
                    <td>{item.name}</td>
                    <td>{item.city}</td>
                    <td>{item.address}</td>
                    <td>{item.phone}</td>
                    <td>{item.fullName}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SupplierWarehouse;
